import { api } from "../Api";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições dos cargos
 */
export class LogsRequest {
    /**
     * Faz a requisição para buscar um log
     * @param {string} id do log
     */
    async getLog(id: string):Promise<any>{
        try {
            const response = await api.get(`/logs/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar um log
     * @param {string} id do log
     */
    async getCommandLog(id: string):Promise<any>{
        try {
            const response = await api.get(`/logs/commands/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar todos os logs
     * @param {string} search termo de busca
     * @param {number} page número da página
     */
    async getAllLogs(search: string ,page: number):Promise<any>{
        try {
            let response = {
                data : []
            }
            if(page && search){
                response = await api.get(`/logs?search=${search}&page=${page}`);
            }else if(search){
                response = await api.get(`/logs?search=${search}`);
            }else if(page){
                response = await api.get(`/logs?page=${page}`);
            }else{
                response = await api.get(`/logs`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar todos os logs de comandos
     * @param {string} search termo de busca
     * @param {number} page número da página
     * @param {string} id_equipment id do equipamento
     */
    async getAllCommandsLogs(search: string ,page: number, id_equipment: string):Promise<any>{
        try {
            let response = {
                data : []
            }
            if(id_equipment){
                response = await api.get(`/logs/commands?id_equipment=${id_equipment}`);
            }else if(page && search){
                response = await api.get(`/logs/commands?search=${search}&page=${page}`);
            }else if(search){
                response = await api.get(`/logs/commands?search=${search}`);
            }else if(page){
                response = await api.get(`/logs/commands?page=${page}`);
            }else{
                response = await api.get(`/logs/commands`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar todos os logs
     * @param {string} datainicio data de inicio
     * @param {string} datafim data de fim
     */
    async getExcel(datainicio: string, datafim: string): Promise<any>{
        try {
            const response = await api.post(`acessLogsExcel`, {
                "datainicio": datainicio,
                "datafim": datafim,
            },{responseType: 'blob', timeout: 300000});
            return response;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar todos os logs
     * @param {string} id_equipment ID do equipamento
     * @param {string} level nível do log
     * @param {string} start_date data de início
     * @param {string} end_date data de fim
     * @param {number} page número da página
     */
    async getAllEquipmentsLogs(id_equipment: string ,level: string, start_date: string, end_date: string, page: number):Promise<any>{
        try {
            const params: Record<string, any> = {};
            if (id_equipment) params.id_equipment = id_equipment;
            if (level) params.level = level;
            if (start_date) params.start_date = start_date;
            if (end_date) params.end_date = end_date;
            if (page) params.page = page;

            const response = await api.get('/equipmentsLogs', { params });

            return response.data;
        } catch (error: any) {
            if (error.response?.status === 401) {
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            } else if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar um log
     * @param {string} id do log
     */
    async getEquipmentLog(id: string):Promise<any>{
        try {
            const response = await api.get(`/equipmentsLogs/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getAllEquipments():Promise<any>{
        try {
            const response = await api.get(`/me/authorizedEquipments`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getAllCities():Promise<any>{
        try {
            const response = await api.get(`/me/authorizedCities`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}